import React from "react";
import { useTaxonomy } from "library/utils/useTaxonomy";
import { CenteredCell } from "../../../components/styled";

interface UsageTypeCellProps {
  usageType?: string | null;
}

export const UsageTypeCell: React.FC<UsageTypeCellProps> = ({ usageType }) => {
  const taxonomy = useTaxonomy();

  if (!usageType) {
    return <CenteredCell>-</CenteredCell>;
  }

  // Look up the taxonomy item by code
  const usageTypeTaxonomy = taxonomy?.VehicleUsageTypeLV?.byId?.[usageType];

  if (!usageTypeTaxonomy) {
    return <CenteredCell>{usageType}</CenteredCell>;
  }

  // Display the code directly (contains the displaytext)
  return <CenteredCell>{usageTypeTaxonomy.code}</CenteredCell>;
};
